<template>
  <v-container fluid fill-height justify-center align-start align-lg-center id="scrolling-techniques-7" class="overflow-y-auto px-0 pb-0" key="settings">
    <div class="max-w pb-0">
      
      <div class="headline font-weight-bold relative px-6 py-2 text--primary">
        {{ $t('Statystyka') }}
      </div>

      <div class="px-4 pb-2">
        <v-select
          :items="charts"
          v-model="currentComponent"
          label="Wybierz przedmiot analizy"
          solo
          hide-details
          prepend-inner-icon="mdi-poll"
          class="shadoww"
        ></v-select>
      </div>

      <div>
        <component v-bind:is="currentComponent"></component>
      </div>

    </div>
  </v-container>
</template>

<script>
import StatTemperatures from '@/components/StatTemperatures.vue'
import StatFuel from '@/components/StatFuel.vue'
import StatFeed from '@/components/StatFeed.vue'

export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    currentComponent: 'StatTemperatures',
    charts: [
      { text: 'Wykres temperatur', value: 'StatTemperatures' },
      //{ text: 'Zuzycie paliwa', value: 'StatFuel' },
      //{ text: 'Zasyp paliwa', value: 'StatFeed' },
    ],
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    currentComponentt: function () {
      return 'StatTemperatures'
    }
  },
  created () {
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId })
    } else {
      
    }
  },
  components: {
    StatTemperatures, StatFuel, StatFeed
  }
}
</script>

<style>
canvas {
  width: 100% !important;
  height: auto;
}

</style>
